import React, { useState, useEffect } from 'react';
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Box,
  Dialog,
  DialogContent,
  Button,
} from '@mui/material';
import axios from 'axios';

// API URL untuk gambar
const UNSPLASH_API_URL = 'https://api.unsplash.com/photos';
const UNSPLASH_ACCESS_KEY = 'YOUR_UNSPLASH_ACCESS_KEY';

const ZodiacLifestyleAndInspiration = () => {
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    // Fetch articles or lifestyle content
    axios.get(`${UNSPLASH_API_URL}?client_id=${UNSPLASH_ACCESS_KEY}&query=lifestyle,inspiration`)
      .then(response => setArticles(response.data))
      .catch(error => console.error(error));
  }, []);

  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Container maxWidth="lg" sx={{ marginTop: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Zodiac Lifestyle & Inspiration
      </Typography>

      <Grid container spacing={4}>
        {articles.map((article, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              <CardMedia
                component="img"
                height="200"
                image={article.urls.regular}
                alt={article.alt_description}
                sx={{ objectFit: 'cover', cursor: 'pointer' }}
                onClick={() => handleClickOpen(article.urls.regular)}
              />
              <CardContent>
                <Typography variant="h6" component="div">
                  {article.alt_description || 'No Title'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {article.description || 'No Description'}
                </Typography>
              </CardContent>
              <Box sx={{ padding: 2, display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  color="primary"
                  href={article.links.html}
                  target="_blank"
                >
                  Learn More
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Dialog for showing the selected image */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogContent>
          <img
            src={selectedImage}
            alt="Selected"
            style={{ width: '100%', height: 'auto' }}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default ZodiacLifestyleAndInspiration;
